import { Box, Group } from '@mantine/core';
import { MessageAttachment } from '../chat/types';
import { ChatFileCard } from './ChatFileCard';

export function ChatFileCardRow({
  files,
  onRemove,
}: {
  files: MessageAttachment[];
  onRemove?: (index: number) => void;
}) {
  if (files.length === 0) return null;

  return (
    <Box style={{ overflowX: 'auto' }}>
      <Group gap="sm" wrap="nowrap" align="stretch">
        {files.map((file, index) => (
          <ChatFileCard
            key={`${file.filename}-${index}`}
            file={file}
            onRemove={onRemove ? () => onRemove(index) : undefined}
          />
        ))}
      </Group>
    </Box>
  );
}
